/* eslint-disable consistent-return */
export const UseFormatador = () => {
  function formatarCPF(cpf_cnpj: string | undefined) {
    if (!cpf_cnpj) return ''
    if (cpf_cnpj.length === 11) {
      const regex = /^(\d{3})(\d{3})(\d{3})(\d{2})$/
      const cpfFormatado = cpf_cnpj.replace(regex, '$1.$2.$3-$4')
      return cpfFormatado
    }
    if (cpf_cnpj.length === 14) {
      const regex = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/
      const cnpjFormatado = cpf_cnpj.replace(regex, '$1.$2.$3/$4-$5')
      return cnpjFormatado
    }
  }
  return {
    formatarCPF,
  }
}
